import {
  DictionariesService,
  DictionaryEnumResponse_ProcessTypeEnum,
  ProcessTypeEnum,
} from '@acme/api';

class ProcessTypesStore {
  private processTypes: DictionaryEnumResponse_ProcessTypeEnum[] | null = null;
  private loadingPromise: Promise<
    DictionaryEnumResponse_ProcessTypeEnum[]
  > | null = null;
  private error: Error | null = null;

  async getProcessTypes(): Promise<DictionaryEnumResponse_ProcessTypeEnum[]> {
    if (this.processTypes) {
      return this.processTypes;
    }

    if (this.loadingPromise) {
      return this.loadingPromise;
    }

    this.loadingPromise = (async () => {
      try {
        const response =
          await DictionariesService.getApiV1DictionariesProcessTypes();
        if (!response.data) {
          throw new Error('No data received from ProcessTypes API');
        }
        this.processTypes = response.data;
        return this.processTypes;
      } catch (err) {
        this.error =
          err instanceof Error ? err : new Error('Failed to load ProcessTypes');
        throw this.error;
      } finally {
        this.loadingPromise = null;
      }
    })();

    return this.loadingPromise;
  }

  getProcessTypesById(
    id: ProcessTypeEnum
  ): DictionaryEnumResponse_ProcessTypeEnum | undefined {
    return this.processTypes?.find((doc) => doc.id === id);
  }

  getProcessTypesByCode(
    code: string
  ): DictionaryEnumResponse_ProcessTypeEnum | undefined {
    return this.processTypes?.find((doc) => doc.name === code);
  }
}

export const processTypesStore = new ProcessTypesStore();
